import {IItemContent} from "../../../typescript-library";
import React from "react";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";
import {SwiperWithTitleAndItems} from "./SwiperBuilder";

// Empfehlungen für Sie (PDP)
const RecommendationsPortal: React.FC<{items: IItemContent[]; element: HTMLElement}> = ({element, items}) => {
  const {t} = useTranslation();

  return ReactDOM.createPortal(
    <SwiperWithTitleAndItems title={t("product.recommendationsForYou")} items={items} context={null} />,
    element,
  );
};

export default RecommendationsPortal;
